import React from "react";

import { Page, Container } from "../elements";

export class NewsPage extends React.Component {
  componentDidMount() {
    if (document.location.hash) {
      this.scrollToElementWithId(document.location.hash);
    }
  }

  scrollTo = (event) => {
    event.preventDefault();
    this.scrollToElementWithId(event.currentTarget.getAttribute("href"));
  };

  scrollToElementWithId = (id) => {
    const section = document.querySelector(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  render() {
    return (
      <Page title="Avvisi" className="news">
        <main>
          <Container>
            <a className="logo" href="/">
              <img
                src="/assets/images/flat-logo.png"
                alt="Youcan Fitness Factory"
              />
            </a>

            <h2>
              Hai scaricato la <strong>nuova App</strong>?
            </h2>

            <h3>
              Con la nuova applicazione <em>"WellnessinCloud"</em> puoi:
            </h3>

            <ul>
              <li>
                <strong>Accedere al club</strong>. La tessera magnetica non è
                più necessaria. Ti basterà aprire l'applicazione, cliccare sul
                pulsante di accesso e passare sul lettore il codice QR.
              </li>
              <li>
                <strong>Prenotare i corsi</strong> e fissare un appuntamento per
                rinnovare la{" "}
                <strong>scheda di allenamento personalizzata</strong>. Una volta
                aperta l'applicazione, ti basta cliccare sul calendario in basso
                a destra e selezionare i servizi che intendi prenotare.
              </li>
              <li>
                <strong>Consultare</strong> autonomamente le scadenze del tuo
                abbonamento e della visita medica.
              </li>
            </ul>

            <h3>...direttamente dal suo smartphone!</h3>

            <p>
              Abbiamo inviato al tuo indirizzo e-mail le istruzioni per
              registrarsi e scaricare l'applicazione. Qualora non le avessi
              ricevute, segnalalo in reception.
            </p>

            <section id="istruzioni-wellnessincloud">
              <h2>
                Istruzioni e regole per la{" "}
                <strong>prenotazione dei corsi</strong>
              </h2>

              <h3>Prenotazione corso</h3>
              <p>
                Hai completato la registrazione e scaricato la nuova App? È il
                momento di prenotare un corso!
              </p>
              <p>
                È semplice:
                <br />
                Accedi all'App e fai clic sull'icona calendario in basso a
                destra, poi fai clic sul pulsante "Corsi" e, con il tasto +,
                scegli il corso a cui desideri partecipare.
              </p>
              <p>
                Puoi avere un <strong>massimo di 2 prenotazioni</strong> attive
                contemporaneamente, anche consecutive. È possibile prenotare un
                corso con un limite massimo di 7 giorni dalla data di inizio.
              </p>

              <h3>Cancellazione</h3>
              <p>
                Se cambi idea puoi cancellarti direttamente dall'App fino a{" "}
                <strong>1 ora prima dell'orario di inizio</strong>.
              </p>
              <p>
                Per vedere e cancellare le tue prenotazioni attive fai clic
                sull'icona calendario in basso a destra, poi fai clic sul
                pulsante "Le mie prenotazioni attive".
              </p>
              <p>
                Quando effettui una prenotazione ad un corso cerca di essere
                puntuale. Per accedere al corso è previsto tuttavia un margine
                di tolleranza di 5 minuti oltre l'orario di inizio.
              </p>
              <p>
                <strong>Attenzione!</strong> Se non ti presenti al corso che hai
                prenotato, l'App potrebbe bloccarti la possibilità prenotare
                altri corsi per i giorni successivi.
              </p>

              <h3>Lista di attesa</h3>

              <p>
                Se il corso a cui vorresti partecipare è pieno,{" "}
                <strong>
                  puoi entrare in lista di attesa attraverso l'App
                </strong>
                .
              </p>
              <p>
                Ogni volta che qualcuno cancella una prenotazione entro 1 ora
                dall'inizio del corso, l'App invia una <strong>notifica</strong>{" "}
                alla prima persona in lista di attesa e la inserisce
                automaticamente tra i prenotati.
              </p>
              <p>
                Le persone in lista di attesa non possono in nessun caso
                prendere il posto di chi è in ritardo.
              </p>

              <h3>Ti ricordiamo che...</h3>
              <p>
                Non è possibile prenotare i corsi o mettersi in lista di attesa
                telefonicamente. La prenotazione dei corsi può avvenire soltanto
                tramite l'App. Per rimanere informati e avere accesso a tutte le
                funzioni ti invitiamo a mantenere attive le{" "}
                <strong>notifiche push</strong>.
              </p>
            </section>
          </Container>
        </main>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/pages/NewsPage.js